export default __webpack_public_path__ + "static/media/healthcare.bce0cbc1.png";